import React from 'react'

const CounsellorProgressBar = ({ comfortableEmotions, uncomfortableEmotions }) => {
    const total = comfortableEmotions + uncomfortableEmotions
    const percentage = total != 0 ? (comfortableEmotions / total) * 100 : 0
    const uncomfortablePercentage = total != 0 ? 100 - percentage : 0

    return (
        <div className="w-full ">
            <div className="w-full bg-[#FC4C5999] rounded-[10px] h-10 relative">
                <div className={`bg-white transition-all ${percentage >= 97 ? 'rounded-[10px]' : 'rounded-l-[10px]'}`} style={{ width: `${percentage}%` }}>
                    <div className={`h-10 bg-[#6FCC8799] w-full ${percentage >= 97 ? 'rounded-[10px]' : 'rounded-l-[10px]'}`}></div>
                </div>
                <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-[#2B793F] text-[16px] leading-4 font-bold">{percentage.toFixed(0)}%</span>
                <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-[#78020B] text-[16px] leading-4 font-bold">{uncomfortablePercentage.toFixed(0)}%</span>
                <div className="absolute top-0  w-full h-10 border-[2px] border-[#ffffff90] rounded-[10px]"></div>
            </div>
        </div>
    )
}

export default CounsellorProgressBar
